import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
} from '@angular/core';
import { GroupedWrit } from '../results/results.component.models';
import { BehaviorSubject } from 'rxjs';
import { BaseComponent } from '@core/base.component';
import { TestHooks } from './execution-diff.hooks';

interface VM {
	groupedWrit: GroupedWrit;
	selectedWritId: string;
	addedExecutions: string[];
	removedExecutions: string[];
	previousExecutions: string[];
	show: boolean;
}

const defaultVM: VM = {
	groupedWrit: null,
	selectedWritId: null,
	addedExecutions: [],
	removedExecutions: [],
	previousExecutions: [],
	show: false,
};

@Component({
	selector: 'app-execution-diff',
	templateUrl: './execution-diff.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ExecutionDiffComponent extends BaseComponent<VM> {
	testHooks = TestHooks;

	@Input()
	set selectedGroup(selectedGroup: GroupedWrit) {
		this.VM = {
			groupedWrit: selectedGroup,
		};
		this.calculate();
	}

	@Input()
	set selectedWritId(id: string) {
		this.VM = {
			selectedWritId: id,
		};
		this.calculate();
	}

	constructor() {
		super(defaultVM);
	}

	calculate() {
		let _show = false;

		const _addedExecutions = [];
		const _removedExecutions = [];
		let _previousExecutions = [];
		if (this.VM.groupedWrit && this.VM.selectedWritId) {
			const ordered = Object.values(this.VM.groupedWrit.writSearches).sort(
				(a, b) =>
					new Date(a?.certificate?.request_date).getTime() -
					new Date(b?.certificate?.request_date).getTime(),
			);
			const selectedPosition = ordered.findIndex(
				(x) => x.id === this.VM.selectedWritId,
			);

			_show = selectedPosition > 0;

			if (_show) {
				const previousExecutions = ordered[selectedPosition - 1].executions;
				const currentExecutions = ordered[selectedPosition].executions;
				Object.keys(currentExecutions).forEach((element) => {
					if (!previousExecutions[element]) {
						_addedExecutions.push(element);
					}
				});

				Object.keys(previousExecutions).forEach((element) => {
					if (!currentExecutions[element]) {
						_removedExecutions.push(element);
					}
				});
				_previousExecutions = Object.keys(previousExecutions);
			}

			// Simon wrote this code but its cyclical
			// const _selectedWrit = this._groupedWrit.writSearches[this._selectedWritId];
			// if(_selectedWrit){
			// 	const _selectedWritExecutions = _selectedWrit.executions;
			// 	const _selectedWritExecutionIds = Object.keys(_selectedWritExecutions);
			// 	const _groupedWritExecutionIds = Object.keys(this._groupedWrit.writSearches);
			// 	_addedExecutions = _groupedWritExecutionIds.filter(x => !_selectedWritExecutionIds.includes(x));
			// 	_removedExecutions = _selectedWritExecutionIds.filter(x => !_groupedWritExecutionIds.includes(x));
			// }
		}

		this.VM = {
			addedExecutions: _addedExecutions,
			removedExecutions: _removedExecutions,
			previousExecutions: _previousExecutions,
			show: _show,
		};
	}
}
